export enum HttpCustomHeaders {
  X_MER_XSRF_TOKEN = 'x-mer-xsrf-token',
}
